import { useEffect, useRef, useState } from "react";
import { getLiveStats } from "@/lib/api";
import { Users, Eye } from "lucide-react";
import { BANNER } from "@/constants/testIds";

// Banner pubblico (sopra il footer) con utenti online in tempo reale e visite di
// oggi. Le visite "di oggi" ripartono automaticamente da 0 ad ogni nuovo giorno.
export const LiveBanner = () => {
  const [stats, setStats] = useState({ online: 0, today: 0 });
  const timer = useRef(null);

  const fetchStats = () => getLiveStats().then(setStats).catch(() => {});

  useEffect(() => {
    fetchStats();
    timer.current = setInterval(fetchStats, 20000);
    return () => clearInterval(timer.current);
  }, []);

  return (
    <div data-testid={BANNER.section} className="border-t border-border bg-secondary/40">
      <div className="container-x py-3 flex flex-col sm:flex-row items-center justify-center gap-x-8 gap-y-2 text-sm">
        <div className="flex items-center gap-2">
          <span className="relative flex h-2.5 w-2.5" aria-hidden="true">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500" />
          </span>
          <Users className="h-4 w-4 text-accent" />
          <span className="text-muted-foreground">Utenti online ora:</span>
          <strong data-testid={BANNER.online} className="font-display text-foreground tabular-nums">{stats.online}</strong>
        </div>

        <div className="hidden sm:block h-4 w-px bg-border" />

        <div className="flex items-center gap-2">
          <Eye className="h-4 w-4 text-accent" />
          <span className="text-muted-foreground">Visite di oggi:</span>
          <strong data-testid={BANNER.today} className="font-display text-foreground tabular-nums">{stats.today}</strong>
        </div>
      </div>
    </div>
  );
};
